import { styled } from "goober";
import { useId } from "react";
import type { Size } from "./Icon";

const Svg = styled("svg")`
  flex-shrink: 0;
  overflow: visible;

  & [data-front],
  & [data-back],
  & [data-cover] {
    transform-box: view-box;
    transform-origin: 1.33px 13.33px;
    transition: transform var(--motion-base) var(--ease-out);
  }

  &[data-open="true"] [data-front] {
    transform: skewX(-30deg) scale(0.9, 0.62);
  }

  &[data-open="true"] [data-back] {
    transform: skewX(8deg);
  }

  &[data-open="true"] [data-cover] {
    transform: translateY(2.78px);
  }
`;

const back =
  "M1.33 11.33V4A2 2 0 0 1 3.33 2H5.29C5.51 2 5.72 2.05 5.92 2.16C6.11 2.26 6.28 2.42 6.4 2.6L6.94 3.4C7.06 3.59 7.23 3.74 7.43 3.84C7.62 3.95 7.84 4 8.07 4H12.67A2 2 0 0 1 14.67 6V11.33A2 2 0 0 1 12.67 13.33H3.33A2 2 0 0 1 1.33 11.33Z";

const front =
  "M1.33 6H14.67V11.33A2 2 0 0 1 12.67 13.33H3.33A2 2 0 0 1 1.33 11.33Z";

export function FolderIcon({
  open,
  size = 16,
  color = "currentColor",
}: {
  open: boolean;
  size?: Size;
  color?: string;
}) {
  const maskId = useId();
  return (
    <Svg
      data-open={open}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <mask id={maskId} maskUnits="userSpaceOnUse">
        <rect x="-4" y="-4" width="24" height="24" fill="white" />
        <path data-front d={front} fill="black" stroke="none" />
        <rect data-cover x="8" y="6" width="12" height="14" fill="black" />
      </mask>
      {/* The mask sits on a group so it stays put while the back tilts. */}
      <g mask={`url(#${maskId})`}>
        <path data-back d={back} vectorEffect="non-scaling-stroke" />
      </g>
      {/* Mitred so the closed flap meets the back flush; the limit bevels the open flap's acute corner. */}
      <path
        data-front
        d={front}
        strokeLinejoin="miter"
        strokeMiterlimit={1.5}
        vectorEffect="non-scaling-stroke"
      />
    </Svg>
  );
}
